export default __webpack_public_path__ + "static/media/video1.f6a34c89.mp4";